<template>
  <section class="topPicksListing defaultSectionMargins">
    <div v-if="data" class="container">
      <h2 v-text="data.title" />
      <Tabs :tabs="tabs" class="topPicksListing__Tabs" :class="{ isLoading: !isFlickityVisible }" v-model="activeTab">
        <template v-for="tabItem in tabs" v-slot:[tabItem.value]>
          <ClientOnly>
            <FlickitySlider :with-progress="showProgressAndButtons(tabItem)" :options="{ ...flickityOptions, prevNextButtons: showProgressAndButtons(tabItem) }" v-if="isFlickityVisible">
              <TopPicksItem v-for="item in tabItem.items" :data="item" />
            </FlickitySlider>
          </ClientOnly>
        </template>
      </Tabs>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });

  const flickityOptions = {
    pageDots: false,
    contain: true,
  }

  const isFlickityVisible = ref(true)
  const tabs = computed(() => {
    return props.data.items.map((item, index) => {
      return {
        title: item.title,
        value: `item${index}`,
        items: item.items
      }
    })
  });
  const activeTab = ref(tabs.value[0].value || null);

  function showProgressAndButtons(item) {
    return window?.innerWidth <= 768 && item.items.length > 1 || window?.innerWidth > 768 && item.items.length > 2
  }

  watch(activeTab, () => {
    isFlickityVisible.value = false
    setTimeout(() => {
      isFlickityVisible.value = true
    }, 1)
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_topPicksListing.scss');
</style>